import React from 'react';
import { Modal } from 'zarm';
import CustomIcon from '../CustomIcon';
import './index.less';
export default function ButtonDelete(props) {
  const {
    onDelete,
    left,
    showDelete = true,
    content = '确认删除?',
    headerClassName
  } = props;

  const handleDelete = () => {
    Modal.confirm({
      title: '操作确认',
      content,
      onOk: onDelete
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: `cc-button-delete ${headerClassName || ''}`
  }, /*#__PURE__*/React.createElement("span", {
    className: "cc-button-delete--l"
  }, left), showDelete && /*#__PURE__*/React.createElement(CustomIcon, {
    type: "delete",
    onClick: handleDelete
  }));
}